/**
 * events epics
 */

import { Injectable } from '@angular/core';

import {
  rx,
  Observable,
  observableOf,
  observableCombineLatest,
} from '@shared/rx';
import { combineEpics, Epic } from 'redux-observable';
import { EventsActions, UiActions } from '../../actions';
import { IAction, IEpicsService, IProcessedEvent } from '@shared/types';
import { DmDataService, XprtDataService } from '@shared/services';
import { reduce, sortBy } from 'lodash';

@Injectable()
export class EventsEpics implements IEpicsService {
  public constructor(
    private dmDataService: DmDataService,
    private xprtDataService: XprtDataService,
    private uiActions: UiActions,
  ) {}

  public getEpic(): Epic<any, any> {
    return combineEpics(this.fetchEventsList.bind(this));
  }

  private fetchEventsList(action$: Observable<IAction>): Observable<IAction> {
    return action$.pipe(
      rx.filter((action) =>
        [EventsActions.FETCH_EVENTS_LIST].includes(action.type),
      ),
      rx.mergeMap((action: IAction) => {
        this.uiActions.enableLoader();

        return observableCombineLatest([
          this.xprtDataService.getEventsByFilter(action.payload),
          this.dmDataService.getEventTypes(),
        ]).pipe(
          rx.map(([events, eventTypes]) => {
            const eventTypeMap = reduce(
              eventTypes,
              (typeMap, eventType) => ({
                ...typeMap,
                [eventType.entity_id]: eventType.name,
              }),
              {},
            );
            const sortedEvents: IProcessedEvent[] = sortBy(
              this.xprtDataService.processEventsList(events, eventTypeMap),
              [
                (event: IProcessedEvent): number => event.status_for_sort,
                (event: IProcessedEvent): number => event.date_for_sort,
              ],
            );
            this.uiActions.disableLoader();

            return EventsActions.fetchEventsListSuccessAction(sortedEvents);
          }),
          rx.catchError((errors) => {
            this.uiActions.disableLoader();

            return observableOf(
              EventsActions.fetchEventsListErrorAction(errors),
            );
          }),
        );
      }),
    );
  }
}
